import { CreneauType } from '../../app.constants';
import { ChampCompteRendu } from '../compte-rendu/champ-compte-rendu.model';
import { INommable } from '../nommable.interface';
import { UUID } from '../uuid.model';
import { VacationRonde } from '../vacation/vacation-ronde.model';
import { Consigne } from './consigne.model';
import { ICreneau } from './creneau.interface';
import { ElementParcours } from './element-parcours.model';
import { Parcours } from './parcours.model';
import { ISite } from './site.interface';
import { Site } from './site.model';
import { Zone } from './zone.model';

export class CreneauRonde implements ICreneau {
  constructor(
    public readonly id: UUID,
    public readonly site: ISite | undefined,
    public vacation?: VacationRonde,
    public readonly consignes?: Consigne[],
    public readonly geolocEnabled?: boolean,
    public readonly signatureEnabled = false,
    public readonly champsPersonnalises: ChampCompteRendu[] = [],
    public readonly zone?: INommable,
    public readonly type = CreneauType.RONDE,
    public readonly parcours: ElementParcours[] = []
  ) {}

  public static hydrate(creneau: CreneauRonde): CreneauRonde {
    return new CreneauRonde(
      creneau.id,
      creneau.site ? Site.hydrate(creneau.site) : undefined,
      creneau.vacation ? VacationRonde.hydrate(creneau.vacation) : undefined,
      creneau.consignes?.map(Consigne.hydrate) ?? [],
      creneau.geolocEnabled,
      creneau.signatureEnabled,
      creneau.champsPersonnalises?.map(ChampCompteRendu.hydrate) ?? [],
      creneau.zone ? Zone.hydrate(creneau.zone) : undefined,
      creneau.type,
      creneau.parcours?.map(Parcours.hydrate) ?? []
    );
  }
}
